import './assets/main.css'
import './assets/tailwind.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from "@sentry/vue"
import App from './App.vue'
import router from './router'

import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ru from './locales/ru'
import ja from './locales/ja'
import de from './locales/de'
import es from './locales/es'
import fr from './locales/fr'
import it from './locales/it'
import ko from './locales/ko'
import pl from './locales/pl'
import pt from './locales/pt'
import tr from './locales/tr'
import zhCN from './locales/zh-cn'
import zhTW from './locales/zh-tw'

const messages = {
  en,
  ru,
  ja,
  de,
  es,
  fr,
  it,
  ko,
  pl,
  pt,
  tr,
  'zh-cn': zhCN,
  'zh-tw': zhTW
}

const urlParams = new URLSearchParams(window.location.search)
const locale = urlParams.get('lang')

const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: 'en', 
  messages
})

const app = createApp(App)
const pinia = createPinia()

const initialKey = 'OWEzNTc0YWQwNTU1YzYzYmZmOWNjNDgwZjA3MTdmYmI='
const publicKey = atob(initialKey)
const dsn = `https://${publicKey}@o4506309501452288.ingest.us.sentry.io/4507775824101376`

const SENTRY_MODES = ['production', 'preproduction']
if (SENTRY_MODES.includes(import.meta.env.MODE)) {
  Sentry.init({
    app,
    dsn: dsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/support-hwmb\.support\.dev\.nexters\.team/,
      /^https:\/\/support-hwa\.techno\.nexters\.com/,
      /^https:\/\/api-support-hwa\.techno\.nexters\.com/
    ],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

app.use(router)
app.use(pinia)
app.use(i18n)

app.mount('#app')